// JsFromRoutes CacheKey 0aa5f440cebf98013275340b78ab59fb
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/payments'),
  show: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/payments/:id'),
}
